// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fade-enter-active[data-v-85c89ebc],.fade-leave-active[data-v-85c89ebc]{transition:opacity .2s}.fade-enter[data-v-85c89ebc],.fade-leave-to[data-v-85c89ebc]{opacity:0}", ""]);
// Exports
module.exports = exports;
